import { Element } from 'common/interfaces'
import { renderRule } from 'views/Flow/renderRule'

import { MustacheCustomRender, useCurrentPage, useTemplateCustomRender } from './hook'

// Get the hidden fields for the current page
const getHiddenFields = (elements: Element[], render: MustacheCustomRender): string[] => {
  const hiddenFields: string[] = []

  elements.forEach((element) => {
    if (element.name && element.render_rules.length > 0) {
      const isVisible = renderRule(element.render_rules, render)

      if (!isVisible) {
        hiddenFields.push(element.name)
      }
    }

    if (element.children?.length > 0) {
      hiddenFields.push(...getHiddenFields(element.children, render))
    }
  })

  return hiddenFields
}

export const useHiddenFields = (): string[] => {
  const currentPage = useCurrentPage()
  const render = useTemplateCustomRender()

  return getHiddenFields(currentPage.elements, render)
}
